import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRolePermission, rolePermissionsSelector, updateUISection } from '../../../store/slices/rolePermissions';

import _, { set } from 'lodash'
import { convertArrayToDictionary, getSalutationSettings } from '../../../common/utils';
import ReactJson from 'react-json-view';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, List, ListItem, ListItemText, ListSubheader, MenuItem, Stack, TextField, Tooltip, Typography, Pagination, Select, FormControl, InputLabel, CircularProgress, Backdrop } from '@mui/material';
import moment from 'moment';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { locationsSelector } from '../../../store/slices/location';
import CustomizeResponse from '../../components/common/reviewComponents/customizeResponse';
import { companiesSelector } from '../../../store/slices/company';
import { getBulkDialogStatus, reviewsSelector, triggerExecutePromptWithJsonData } from '../../../store/slices/reviews';
import { filtersSelector } from '../../../store/slices/fliters';
import ChatDataComponent from './chatDataComponent';
import { index } from 'd3';
import { logSelector } from '../../../store/slices/logs';
import { v4 as uuidv4 } from 'uuid';
import CloseIcon from "@mui/icons-material/Close";
import { isValidJSON } from '../../components/common/reviewComponents/reviewUtils';
import InterComDataModal from './interComDataModal';
import { intercomSelector } from '../../../store/slices/intercom';
import DataImportModal from './dataImportModal';
import FetchImportModal from './fetchImportModal';
import BulkProcessDatesModal from './bulkProcessDatesModal';




const Chat = React.memo(({ }) => {
  const [jsonData, setJsonData] = useState([]);
  const [fileInputValue, setFileInputValue] = useState(null);
  const { prompts } = useSelector(locationsSelector)
  const {loading, intercomData}=useSelector(intercomSelector)
  const [indexInputValue, setIndexInputValue] = useState('1');

  const defaultGuid = "00000000-0000-0000-0000-000000000000";

  
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedReviewText, setSelectedReviewText] = useState([]);
  const [selectedReviewIds, setSelectedReviewIds] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [gptUsage, setGptUsage] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [text, setText] = useState('');

  const [customSettings, setCustomsettings] = useState({});
  const [promptOutput, setPromptOutput] = useState(null);
  const [isMultiple, setIsMultiple] = useState(false);
  const [selectedReview, setSelectedReview] = useState([]);
  const [indexValue, setIndexValue] = useState({fromToIndex:{from: null, to: null}, singleIndex: 1});
  const [indexValueDummy, setIndexValueDummy] = useState({fromToIndex:{from: null, to: null}, singleIndex: 1});
  const promptsDic = React.useMemo(() => {
    return convertArrayToDictionary(prompts, 'promptId');
  }, [prompts]);

  const isValidIndex = useMemo(() => {
    const num = parseInt(indexInputValue);
    return num >= 1 && num <= (jsonData?.length || 1);
  }, [indexInputValue, jsonData?.length]);


  const [loadedItemsCount, setLoadedItemsCount] = useState(50);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  const [searchTerm, setSearchTerm] = useState('');
  const [searchField, setSearchField] = useState('all'); // 'all', 'id', 'remark', 'parts'

  // Loading state
  const [isLoadingJson, setIsLoadingJson] = useState(false);
  const [openModal,setOpenModal]=React.useState(false)
  const [openBulkModal,setOpenBulkModal]=React.useState(false)
  const [openExportModal,setOpenExportModal]=React.useState(false)
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [openChat, setOpenChat] = React.useState(false);
  const [promptName, setPromptName] = useState("");
  const [promptType, setPromptType] = useState("");
  const [promptId, setPromptId] = useState(null);
  const [reviewSelectionType, setReviewSelectionType] = useState("");
  const [llm, setLlm] = useState("gpt-4");
  const [temperature, setTemperature] = useState(0);
  const [seed, setSeed] = useState("None");
  const [inputFactor, setInputFactor] = useState(40);
  const [jsonResponse, setJsonResponse] = useState(false);
  const [jsonResponseSchema, setJsonResponseSchema] = useState(false);
  const [maxLength, setMaxLength] = useState(0);
  const [topP, setTopP] = useState(1);
  const [presencePenalty, setPresencePenalty] = useState(0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0);
  const [jsonResponseSchemaValue, setJsonResponseSchemaValue] = useState("");
  const [promptsInput, setPromptsInput] = useState({})
  const [prompt, setPrompt] = useState("");
  const [systemPrompt, setSystemPrompt] = useState("");
  const [selectedPromt, setSelectedPromt] = useState(null);
  const {localState:{openBulk}, executePromptWithJsonData} = useSelector(reviewsSelector);
  const [fileName, setFileName] = useState('');
  const [openLoadDataModal, setOpenLoadDataModal] = useState(false);

 
 
  const handlePromptChange = useCallback((newPromptId, newPromptName, newPromptType, newPrompt) => {
    setPromptId(newPromptId);
    setPromptName(newPromptName);
    setPromptType(newPromptType);
    setPrompt(newPrompt);
    setSystemPrompt(newPrompt.systemPrompt || "");
  }, []);
  useEffect(() => {
    const promptId = localStorage.getItem('chatPrompt') ? JSON.parse(localStorage.getItem('chatPrompt'))?.promptId : null;
    if (promptId) {
      const foundPrompt = _.find(prompts, { promptId: promptId });
      if (foundPrompt) {
        setPromptId(foundPrompt.promptId);
        setPrompt(foundPrompt.prompt);
        setSystemPrompt(foundPrompt.systemPrompt || "");
        setSystemPrompt(foundPrompt.systemPrompt || "");
        setPromptName(foundPrompt.name);
        setPromptType(foundPrompt.type);
      }
    }
  }, [promptId]);

  const handlePromptSettingsChange = useCallback((settings) => {
    if (settings.llm) setLlm(settings.llm);
    if (settings.temperature !== undefined) setTemperature(settings.temperature);
    if (settings.seed) setSeed(settings.seed);
    if (settings.inputFactor !== undefined) setInputFactor(settings.inputFactor);
    if (settings.jsonResponse !== undefined) setJsonResponse(settings.jsonResponse);
    if (settings.jsonResponseSchema !== undefined) setJsonResponseSchema(settings.jsonResponseSchema);
    if (settings.maxLength !== undefined) setMaxLength(settings.maxLength);
    if (settings.topP !== undefined) setTopP(settings.topP);
    if (settings.presencePenalty !== undefined) setPresencePenalty(settings.presencePenalty);
    if (settings.frequencyPenalty !== undefined) setFrequencyPenalty(settings.frequencyPenalty);
    if (settings.jsonResponseSchemaValue) setJsonResponseSchemaValue(settings.jsonResponseSchemaValue);
  }, []);

  const handlePromptsInputChange = useCallback((newPromptsInput) => {
    setPromptsInput(newPromptsInput);
  }, []);


  
  const { companies, loadingCompany } = useSelector(companiesSelector);
  const companyDic = React.useMemo(() => convertArrayToDictionary(companies, 'companyId'), [companies])
  const { executePromptMultiple, similarReviews, loadingReviews, generateResponse } = useSelector(reviewsSelector);
  const [bulkData, setBulkData] = useState({});
  const [ignoreIds, setIgnoreIds] = useState('');
  const { filters } = useSelector(filtersSelector);
   const { apiKey } = useSelector(logSelector);
   
   const dispatch = useDispatch();
  const companyId = useMemo(() => filters?.companyId, [filters]);
  const handleFileUpload = useCallback((e) => {
    const file = e.target.files[0];

    if (file) {
      setIsLoadingJson(true); // Start loading
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const parsed = JSON.parse(event.target.result);
          
         
          setTimeout(() => {
            setJsonData(parsed);
            setIndexInputValue('1');
            setIndexValue({fromToIndex:{from: null, to: null}, singleIndex: 1});
            setIndexValueDummy({fromToIndex:{from: null, to: null}, singleIndex: 1});
            setCurrentPage(1);
            setSearchTerm(''); 
            setIsLoadingJson(false); 
          }, 100);
        } catch (error) {
          alert("Invalid JSON file!");
          setIsLoadingJson(false); 
          
          if (fileInputValue) {
            setFileInputValue('');
          }
          setJsonData(null);
        }
      };
      
      reader.onerror = () => {
        alert("Error reading file!");
        setIsLoadingJson(false); 
      };
      
      reader.readAsText(file);
    }
  }, [fileInputValue]);
  useEffect(() => {
    if (filters?.companyId) {
      setSelectedCompany(filters?.companyId);
    }
  }, [filters]);


useEffect(()=>{
  if(intercomData && intercomData.length>0){
    setJsonData(intercomData);
    setIndexInputValue('1');
    setIndexValue({fromToIndex:{from: null, to: null}, singleIndex: 1});
    setIndexValueDummy({fromToIndex:{from: null, to: null}, singleIndex: 1});
    setCurrentPage(1);
    setSearchTerm(''); 
  }
},[intercomData]);



  const handleIndexChange = useCallback(() => {
    const selectedIndex = parseInt(indexInputValue);
    

    if(selectedIndex >= 1 && selectedIndex <= jsonData.length) {
      setIndexValue((prev)=>({ ...prev, singleIndex: selectedIndex }));
    }
  }, [indexInputValue, jsonData.length]);

 
  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);


  const filteredData = useMemo(() => {
    if (!jsonData || !Array.isArray(jsonData)) return [];
    if (!searchTerm.trim()) return jsonData;

    const searchLower = searchTerm.toLowerCase();
    
    return jsonData.filter(item => {
      if (searchField === 'all') {
        
        const searchableText = [
          item?.id?.toString(),
          item?.remark,
          item?.rating?.toString(),
          ...(item?.parts?.map(part => `${part?.authorType} ${part?.body}`) || [])
        ].join(' ').toLowerCase();
        
        return searchableText.includes(searchLower);
      }
      
      if (searchField === 'id') {
        return item?.id?.toString().toLowerCase().includes(searchLower);
      }
      
      if (searchField === 'remark') {
        return item?.remark?.toLowerCase().includes(searchLower);
      }
      
      if (searchField === 'parts') {
        return item?.parts?.some(part => 
          part?.authorType?.toLowerCase().includes(searchLower) ||
          part?.body?.toLowerCase().includes(searchLower)
        );
      }
      
      return false;
    });
  }, [jsonData, searchTerm, searchField]);

 
  const totalPages = useMemo(() => {
    return filteredData ? Math.ceil(filteredData.length / itemsPerPage) : 1;
  }, [filteredData, itemsPerPage]);

  
  const displayData = useMemo(() => {
    if (!filteredData || !Array.isArray(filteredData)) return [];
    
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    
    return filteredData.slice(startIndex, endIndex).map((item, index) => ({
      ...item,
      originalIndex: jsonData.findIndex(original => original === item) 
    }));
  }, [filteredData, currentPage, itemsPerPage, jsonData]);

  const fromToArr = useMemo(() => {
    if (indexValueDummy.fromToIndex.from && indexValueDummy.fromToIndex.to) {
      return jsonData?.slice(indexValueDummy.fromToIndex.from - 1, indexValueDummy.fromToIndex.to) || [];
    }
    return [];
  }, [indexValueDummy, jsonData]);
  
  const indexObj = React.useMemo(() => {
    return jsonData[indexValue.singleIndex-1] ? JSON.stringify(jsonData[indexValue.singleIndex-1], null, 2) : ''
  }, [indexValue.singleIndex, jsonData]);

  useEffect(() => {
    if (jsonData) {
      setCurrentPage(1);
    }
  }, [jsonData]);

  
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, searchField]);

  const handleExpaneCollapse = useCallback(() => {
    setOpenChat({ expandAll: !openChat.expandAll });
  }, [openChat.expandAll]);

   useEffect(() => {
      if (promptId) {
  
        const foundPrompt = _.find(prompts, { promptId: promptId });
        if (foundPrompt) {
          const defaultParametersObj = JSON.parse(foundPrompt.defaultParameters);
          const setOrDefault = (stateSetter, value, defaultValue) => {
            stateSetter(defaultParametersObj?.[value] ?? defaultValue);
          };
          // if (isPrompt) {
          //   setCustomsettings({
          //     executeParallel:
          //       foundPrompt.reviewSelectionType === "Multiple" ? true : false,
          //     singleReview: false,
          //   });
          // }
          setLlm(foundPrompt.llm);
          setReviewSelectionType(foundPrompt.reviewSelectionType);
          setPrompt(foundPrompt.promptText);
          setSystemPrompt(foundPrompt.systemPrompt || "");
          setJsonResponseSchemaValue(foundPrompt.responseJsonSchema);
          setOrDefault(setTemperature, "temperature");
          setJsonResponseSchema(defaultParametersObj?.['isJsonResponseSchema'])
          // setOrDefault(setJsonResponseSchema, "isJsonResponseSchema");
          setOrDefault(setSeed, 'seed', 'None')
          setOrDefault(setTopP, "topP", 1);
          setOrDefault(setMaxLength, "maxLength");
          setOrDefault(setPresencePenalty, "presencePenalty");
          setOrDefault(setFrequencyPenalty, "frequencyPenalty");
          setOrDefault(setInputFactor, "inputFactor");
          setOrDefault(setJsonResponse, "jsonResponse");
          // if (isPrompt) {
  
          //   setIsMultiple(
          //     foundPrompt.reviewSelectionType === "Single" ? false : true
          //   );
          //   setSelectedReviewIds([]);
          //   setSelectedReviewText([]);
          // }
          // if (isSentiment) {
          //   setIsMultiple(
          //     foundPrompt.reviewSelectionType === "Single" ? false : true
          //   );
          // }
        }
      }
    }, [promptId]);




  const companyData = React.useMemo(
    () => _.find(companies, { companyId: selectedCompany }),
    [companies, selectedCompany]
  );

  // Helper function for prompt preview
  const handlePromptPreview = (selectedCompany) => {
    const localStorageData = getSalutationSettings(selectedCompany)
    let input = {}
    if (!_.isEmpty(localStorageData)) {
      const closing = localStorageData?.Closing
      if (_.trim(closing?.text) && !_.isEmpty(_.trim(closing?.text))) {
        input['Closing'] = _.trim(closing?.text) ?? ''
      }
      input['ClosingPlacement'] = closing?.paragraph ? 'SeparateParagraph' : 'Other'
      const greeting = localStorageData?.Greeting
      if (_.trim(greeting?.text) && !_.isEmpty(_.trim(greeting?.text))) {
        const additionalText = greeting.additionalText ?? ""
        input['Greeting'] = greeting?.text === '[Name Only]' ? _.trim(additionalText) : _.trim((greeting?.text ?? "") + " " + additionalText)
      }
      input['GreetingPlacement'] = greeting?.default ? 'NameOnly' : greeting?.paragraph ? 'SeparateParagraph' : 'Other'
      const businessName = localStorageData?.BusinessName
      if (_.trim(businessName?.text) && !_.isEmpty(_.trim(businessName?.text))) {
        input['BusinessName'] = _.trim(businessName?.text) ?? ""
      }
      const contactPhrase = localStorageData?.ContactPhrase
      if (_.trim(contactPhrase?.text)) {
        input['ContactPhrase'] = _.trim(contactPhrase?.text) ?? ''
      }
      const contactInfo = localStorageData?.ContactInfo
      if (_.trim(contactInfo?.text)) {
        input['ContactInfo'] = _.trim(contactInfo?.text) ?? ''
      }
    }
    return input;
  };


  const handleBulkProcess = (isBulkProcess = false,startDate,endDate) => {
   
    if (!promptId || !prompt || prompt.trim() === '') {
      alert('Please select a prompt before processing.');
      return;
    }

    let requestId = uuidv4();
    // let isDataType = _.toLower(prompt).includes(_.toLower("%NumberAndTextArray%")) || _.toLower(prompt).includes(_.toLower("%ReviewTopicSentimentsArray%")) || _.toLower(prompt).includes(_.toLower("{{ ChatData }}"));
    let isDataType = false;
    // let dataTypeKeyword = _.toLower(prompt).includes(_.toLower("%NumberAndTextArray%")) ? 'NumberAndTextArray' : _.toLower(prompt).includes(_.toLower("%ReviewTopicSentimentsArray%")) ? 'ReviewTopicSentimentsArray' 
    // :  _.toLower(prompt).includes(_.toLower("{{ ChatData }}"))?'ChatData':'';
    let dataTypeKeyword = 'ChatData'; 

    let data = null;
    
    if (isBulkProcess) {
      
      data = fromToArr?.length > 0 ? fromToArr.map(item => JSON.stringify({...item, Id: item.id})) : [];
      
    } 
    const Input = handlePromptPreview(selectedCompany)
    let inputValues = _.isEmpty(Input) ? { ...promptsInput } : { ...Input, ...promptsInput, AboutUs: companyData?.description ?? '' };
    if (companyData?.donotUseTranslation) {
      inputValues['DonotUseTranslation'] = 'true';
    }

    let promptInput = {
      prompt: {
        prompt: prompt,
        systemPrompt: systemPrompt,
        temperature: parseFloat(temperature),
        maxLength: parseInt(maxLength),
        topP: parseFloat(topP),
        cachingKey: promptsDic?.[promptId]?.cachingKey ? (promptsDic?.[promptId]?.cachingKey + ':pg') : null,
        llm: llm,
        seed: seed,
        presencePenalty: parseFloat(presencePenalty),
        jsonResponse: jsonResponse ? jsonResponse : false,
        frequencyPenalty: parseFloat(frequencyPenalty),
        companyId: selectedCompany ? selectedCompany : defaultGuid,
        isJsonResponseSchema: jsonResponseSchema,
        responseJsonSchema: jsonResponseSchemaValue,
        inputFactor: parseInt(inputFactor),
        deepResearch: false
      },
      input: {},
      data: data,
      parallel: isBulkProcess,
      processSingleReview: !isBulkProcess,
      dataType: { 
        name: dataTypeKeyword || "ChatData", 
        isObjectArray: isDataType ?? false 
      }
    };

    let extraData = {
      promptId: promptId,
      promptName: promptName,
      promptType: promptType,
      reviewId: defaultGuid,
      businessType: companyData?.businessType || "",
      requestId: requestId,
      step: "",
      process: "",
      apiKey: apiKey
    };

    const payload = {
      promptInput: promptInput,
      extraData: extraData,
      ignoreIds: isValidJSON(ignoreIds) ? JSON.parse(ignoreIds) : [],
      startDate: startDate,
      endDate: endDate 
    };


    setBulkData(payload);
    dispatch(
      triggerExecutePromptWithJsonData(payload, selectedCompany, requestId)
    );
    
    setSelectedId(requestId);
    setRefresh(!refresh);
  };
  const bulkProcessFunctions=(startDate,endDate)=>{
    handleBulkProcess(true,startDate,endDate)
  }
  const handleDownloadJsonClose = () => {
    dispatch(getBulkDialogStatus(false));
  }

  
const handleDownloadJson = (name) => {
  try {
    
    const responseData = executePromptWithJsonData?.[selectedId];
    
    
    if (!responseData) {
      alert('No data available to download. Please run the bulk process first.');
      return;
    }

    
    let dataToDownload;
    if (responseData) {
      dataToDownload = responseData;
    } else if (Array.isArray(responseData)) {
      dataToDownload = responseData;
    } else {
      dataToDownload = responseData;
    }

    const jsonString = JSON.stringify(dataToDownload, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
 
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name || 'chat_data'}.json`;
    document.body.appendChild(link);
    link.click();
    
    
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
   
    // handleDownloadJsonClose();
     dispatch(getBulkDialogStatus(false))
    setFileName("");
    
  } catch (error) {
    console.error('Error downloading JSON:', error);
    alert('Error downloading file. Please try again.');
  }
};


useEffect(() => {
  if (selectedId && executePromptWithJsonData?.[selectedId] && openBulk) {
    handleDownloadJson();
  }
}, [executePromptWithJsonData, selectedId, openBulk]);


  return (
    <div>


      <Grid container spacing={2} sx={{ mt: '0' }}>

        <Grid item xs={6} md={6} lg={6} sx={{ paddingLeft: 2, borderRight: '1px solid #ccc', paddingRight: 2 }}>
          <Stack direction="row" spacing={2} justifyContent={'space-between'} sx={{ mb: 2}}>
          <Typography variant="h5">FH Chats</Typography>
          <div>
            <Button variant="contained" color="primary" size="small" sx={{ textTransform: "none" }} onClick={()=>setOpenModal(true)}>Import Intercom Data</Button>
            <Button variant="contained" color="primary" size="small" sx={{ textTransform: "none", ml: 1 }} onClick={()=>setOpenExportModal(true)}>Export Intercom Data</Button>
          </div>
          </Stack>
            <Stack spacing={2} direction="row" alignItems="center" justifyContent="space-between">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
               <Button variant="contained" color="primary" size="small" sx={{ textTransform: "none" }}  onClick={() => setOpenLoadDataModal(true)}>Load DB Data</Button>
              {/* <input type="file" value={fileInputValue} accept=".json" onChange={handleFileUpload} disabled={isLoadingJson} style={{width:'180px'}}/> */}
              {/* {isLoadingJson && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CircularProgress size={20} />
                  <Typography variant="body2" color="text.secondary">Processing...</Typography>
                </Box>
              )} */}
            </Box>
            <Stack direction="row" spacing={1} alignItems="center">
              {jsonData.length > 5 && (
                <Box sx={{ mt: 2, mb: 2 }}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <TextField
                      label="Search"
                      variant="outlined"
                      size="small"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Search chat data..."
                      
                    />
                  
                    {/* {searchTerm && (
                      <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                        {filteredData.length} of {jsonData.length} items
                      </Typography>
                    )} */}
                  </Stack>
                </Box>
          )}
              {_.size(jsonData) > 0 && (
                <Button variant="contained" onClick={handleExpaneCollapse} color="primary">
                  {openChat?.expandAll ? 'Collapse All' : 'Expand All'}
                </Button>
              )}
            </Stack>
          </Stack>

          {/* Search Controls */}
          
          {jsonData && <> <Box sx={{ 
            minHeight: 'calc(100vh - 340px)', 
            maxHeight: 'calc(100vh - 340px)', 
            overflowY: 'auto', 
            marginTop: '20px',
            position: 'relative' // For loader positioning
            // border: '1px solid #bcc1caa6', borderRadius: '6px', padding: 3 
            }}>
            
            {/* Loading Overlay */}
            {isLoadingJson && (
              <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10,
                borderRadius: '8px'
              }}>
                <Box sx={{ textAlign: 'center' }}>
                  <CircularProgress size={40} />
                  <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                    Loading JSON data...
                  </Typography>
                </Box>
              </Box>
            )}
            {/* Top Pagination */}
            {/* {totalPages > 1 && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="body2" color="textSecondary">
                  Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, jsonData.length)} of {jsonData.length} items
                </Typography>
                <Pagination 
                  count={totalPages} 
                  page={currentPage} 
                  onChange={(event, page) => handlePageChange(page)}
                  color="primary"
                  size="small"
                  showFirstButton 
                  showLastButton
                />
              </Box>
            )} */}

            {/* <ReactJson src={jsonData} collapsed={1} displayDataTypes={false} /> */}
              <ChatDataComponent 
                chatData={displayData} 
                openChat={openChat} 
                setOpenChat={setOpenChat}
                totalCount={jsonData?.length || 0}
                selectedIndex={indexValue.singleIndex}
              />

            {/* Bottom Pagination */}
           
          </Box>
          <Stack spacing={2} direction="row" alignItems="center" justifyContent="end" pt={2}>
              {totalPages > 1 && (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
                {searchTerm && (
                  <Typography variant="body2" color="textSecondary">
                    Page {currentPage} of {totalPages} (filtered results)
                  </Typography>
                )}
                <Pagination 
                  count={totalPages} 
                  page={currentPage} 
                  onChange={(event, page) => handlePageChange(page)}
                  color="primary"
                  showFirstButton 
                  showLastButton
                />
              </Box>
            )}
          </Stack>
          <Stack spacing={2} direction="row" alignItems="center" justifyContent="end" pt={2} pb={2}>
            <Box sx={{ display: 'flex', alignItems: 'end', justifyContent: 'end', gap: 2, marginTop: 2 }}>
              <TextField
                label="From Index"
                variant="outlined"
                type="number"
                value={indexValueDummy.fromToIndex.from}
                onChange={(e) => setIndexValueDummy((prev)=>({...prev, fromToIndex: {...prev.fromToIndex, from: e.target.value}}))}
                size='small'
                sx={{ width: '120px' }}
              />
              <TextField
                label="To Index"
                variant="outlined"
                type="number"
                value={indexValueDummy.fromToIndex.to}
                onChange={(e) => setIndexValueDummy((prev)=>({...prev, fromToIndex: {...prev.fromToIndex, to: e.target.value}}))}
                size='small'
                sx={{ width: '110px' }}
              />

              <TextField
                label="Ignore IDs (JSON array)"
                variant="outlined"
                multiline
                rows={2}
                value={ignoreIds}
                onChange={(e) => setIgnoreIds(e.target.value)}
                placeholder="e.g., [1, 5, 10, 15, 20]"
                size='small'
                sx={{ width: '200px' }}
                // helperText="Enter JSON array of IDs to skip"
              />
              
              <Button variant="contained" onClick={() => {
                if (indexValueDummy.fromToIndex.from && indexValueDummy.fromToIndex.to) {
                  handleIndexChange("fromTo");
                  // Wait for state update then trigger bulk process
                 setOpenBulkModal(true);
                }
              }} 
              disabled={!indexValueDummy.fromToIndex.from || !indexValueDummy.fromToIndex.to || !promptId || !prompt}
              color="primary" sx={{ textTransform: "none" }}>Bulk Process</Button>
            </Box>

           {jsonData.length > 0 && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 2, marginTop: 2 }}>

              <TextField
                label="Index"
                variant="outlined"
                type="number"
                value={indexInputValue}
                onChange={(e) => setIndexInputValue(e.target.value)}
                size='small'
                sx={{ width: '90px' }}
                inputProps={{
                  min: 1,
                  max: jsonData?.length || 1
                }}
              />
              <Button 
                variant="contained" 
                onClick={handleIndexChange} 
                color="primary"
                disabled={!isValidIndex}
                sx={{ minWidth: '70px' }}
              >
                Select
              </Button>
            </Box>}
            
            </Stack>
            </>}
        </Grid>
        <Grid item xs={6} md={6} lg={6} sx={{}}>
          <Box sx={{ minHeight: 'calc(100vh - 156px)', maxHeight: 'calc(100vh - 156px)', overflowY: 'auto', marginTop: '20px', }}>
           

            <CustomizeResponse
              selectedCompany={selectedCompany}
              selectedReviewText={selectedReviewText}
              selectedReviewIds={selectedReviewIds}
              setRefresh={setRefresh}
              refresh={refresh}
              gptUsage={gptUsage}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
              text={text}
              indexObj={indexObj}
              setText={setText}
              customSettings={customSettings}
              setCustomsettings={setCustomsettings}
              promptOutput={promptOutput}
              setPromptOutput={setPromptOutput}
              isPrompt={false}
              setIsMultiple={setIsMultiple}
              isMultiple={isMultiple}
              setSelectedReviewIds={setSelectedReviewIds}
              setSelectedReviewText={setSelectedReviewText}
              selectededReview={selectedReview}
              boxHeight={169}
              
              // Pass prompt-related props
              promptName={promptName}
              setPromptName={setPromptName}
              promptType={promptType}
              setPromptType={setPromptType}
              promptId={promptId}
              setPromptId={setPromptId}
              prompt={prompt}
              setPrompt={setPrompt}
              systemPrompt={systemPrompt} setSystemPrompt={setSystemPrompt}
              llm={llm}
              setLlm={setLlm}
              temperature={temperature}
              setTemperature={setTemperature}
              seed={seed}
              setSeed={setSeed}
              inputFactor={inputFactor}
              setInputFactor={setInputFactor}
              jsonResponse={jsonResponse}
              setJsonResponse={setJsonResponse}
              jsonResponseSchema={jsonResponseSchema}
              setJsonResponseSchema={setJsonResponseSchema}
              maxLength={maxLength}
              setMaxLength={setMaxLength}
              topP={topP}
              setTopP={setTopP}
              presencePenalty={presencePenalty}
              setPresencePenalty={setPresencePenalty}
              frequencyPenalty={frequencyPenalty}
              setFrequencyPenalty={setFrequencyPenalty}
              jsonResponseSchemaValue={jsonResponseSchemaValue}
              setJsonResponseSchemaValue={setJsonResponseSchemaValue}
              promptsInput={promptsInput}
              setPromptsInput={setPromptsInput}
              selectedPromt={selectedPromt}
              setSelectedPromt={setSelectedPromt}
              
              onPromptChange={handlePromptChange}
              onPromptSettingsChange={handlePromptSettingsChange}
              onPromptsInputChange={handlePromptsInputChange}
              chatId={isValidJSON(indexObj)? JSON.parse(indexObj)?.id : null} 
              chatData={true}
            />
          </Box>
        </Grid>

      </Grid>

      {/* {openBulk &&
         <Dialog open={openBulk} onClose={handleDownloadJsonClose}>
            <DialogTitle>
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Typography variant="h6">Download Json</Typography>
                <IconButton onClick={handleDownloadJsonClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            </DialogTitle>
            <DialogContent dividers sx={{ padding: 4 }}>
              
                <TextField
                  label="File Name"
                  variant="outlined"
                  fullWidth
                  value={fileName}
                  onChange={(e) => setFileName(e.target.value)}
                  size='small'
                />
            </DialogContent>
            <DialogActions>
                  <Stack
                    direction="row"
                    spacing={2}
                    ml={2}
                    py={1}
                    sx={{ width: "100%" }}
                  >
                   
                   {<Button
                      variant="contained"
                      // disabled={_.isEmpty(comparePrompt)}
                      onClick={()=>handleDownloadJson(fileName)}
                    >
                      Download JSON
                    </Button>}
                   
                    <Button variant="outlined" onClick={handleDownloadJsonClose}>
                      Cancel
                    </Button>
                  </Stack>
                </DialogActions>
            </Dialog>
            
      } */}
       {loading&&<Backdrop open={loading} sx={{ zIndex: 10 }}>
                      <Stack sx={{ position: 'relative' }} direction='row'>
                          <Typography variant="h4" color={'#fff'}>Getting Chats</Typography>
                          <div style={{ position: 'absolute', right: -30, bottom: 10 }}>
                              <div className="dot-typing"></div>
                          </div>
                      </Stack>
                  </Backdrop>}
      {openModal && <InterComDataModal
        open={openModal}
        handleClose={() => {setOpenModal(false);setOpenBackdrop(true)}}
      />}
      {openExportModal && <DataImportModal
        open={openExportModal}
        handleClose={() => setOpenExportModal(false)}
      />}
{openLoadDataModal && <FetchImportModal open={openLoadDataModal} handleClose={() => setOpenLoadDataModal(false)} />}
      {openBulkModal && <BulkProcessDatesModal
        open={openBulkModal}
        handleClose={() => {setOpenBulkModal(false);setOpenBackdrop(true)}}
        handleFunc={bulkProcessFunctions}
      />}
    </div>
  );
});

export default Chat;









